/**
 * 获取一个全透明的svg图片
 * @param {number} w 透明图片的宽度
 * @param {number} h 透明图片的高度
 */
export const getEmptySVG = function (w, h) {
  return genSVG(`<svg viewBox="0 0 ${w} ${h}" width="${w}" height="${h}" xmlns="http://www.w3.org/2000/svg"></svg>`)
}
function genSVG (rawSVG) {
  return 'data:image/svg+xml;charset=utf-8,' + encodeURI(rawSVG).replace(/[\n\r]/gi, '').replace(/#/g, '%23')
}

/**
 * 获取一个loading的SVG图片
 * @param {color} color svg图片的颜色
 * @param {number} type loading图片的样式，支持 1/2/3
 */
export const getLoadingSVG = function (color = '#eee', type = 1) {
  switch (type) {
    case 1:
      return genSVG(`<svg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
      <circle cx="50" cy="50" r="27.1897" fill="none" stroke="${color}" stroke-width="10">
      <animate attributeName="r" calcMode="spline" values="0;40" keyTimes="0;1" dur="1" keySplines="0 0.2 0.8 1" begin="-0.5s" repeatCount="indefinite"></animate>
      <animate attributeName="opacity" calcMode="spline" values="1;0" keyTimes="0;1" dur="1" keySplines="0.2 0 0.8 1" begin="-0.5s" repeatCount="indefinite"></animate>
      </circle>
      <circle cx="50" cy="50" r="3.96265" fill="none" stroke="${color}" stroke-width="10">
      <animate attributeName="r" calcMode="spline" values="0;40" keyTimes="0;1" dur="1" keySplines="0 0.2 0.8 1" begin="0s" repeatCount="indefinite"></animate>
      <animate attributeName="opacity" calcMode="spline" values="1;0" keyTimes="0;1" dur="1" keySplines="0.2 0 0.8 1" begin="0s" repeatCount="indefinite"></animate>
      </circle>
      </svg>`)
    case 2:
      return genSVG(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <circle cx="50" cy="50" fill="none" stroke="${color}" stroke-width="6" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(83.9772 50 50)">
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
      </circle>
      </svg>`)
    case 3:
      return genSVG(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100px" height="100px" viewBox="0 0 100 100">
      <circle cx="50" cy="50" r="23" stroke-width="6" stroke="${color}" stroke-dasharray="36.12831551628262 36.12831551628262" fill="none" stroke-linecap="round" transform="rotate(155.974 50 50)">
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
      </circle>
      </svg>`)
  }
}
/**
 * 获取一个对勾SVG图片
 * @param {color} background svg图片背景色
 * @param {color} color svg图片的勾勾颜色
 * @param {color|Empty} borderColor 圆形外围描边颜色，不提供则不描边
 */
export const getGouSVG = function (background = '#7ac142', color = '#fff', borderColor = '') {
  const strokeWidth = borderColor ? 3 : 0
  return genSVG(`<svg viewBox='0 0 50 50' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
  <circle cx="25" cy="25" r="24" fill="${background}" stroke-width="${strokeWidth}" stroke="${borderColor}"/>
  <path stroke-width="3" stroke="${color}" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
</svg>`)
}

/**
 * 获取一个环形svg图片
 * @param {color} background 环形svg图片的背景色
 * @param {color} color 环形内环的填充色
 * @param {color|Empty} borderColor 圆形描边的颜色
 */
export const getCircleSVG = function (background = '#7ac142', color = '#fff', borderColor = '') {
  const strokeWidth = borderColor ? 3 : 0
  return genSVG(`<svg viewBox='0 0 50 50' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
  <circle cx="25" cy="25" r="24" fill="${background}" stroke-width="${strokeWidth}" stroke="${borderColor}"/>
  <circle cx="25" cy="25" r="8" fill="${color}"/>
</svg>`)
}

/**
 * 获取一个返回顶部的SVG图片
 * @param {color} color 返回顶部的icon填充色
 */
export const getGoTopSVG = function (color = '#eee') {
  return genSVG(`<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
    <path fill="${color}" d="M906.38 77.46h-781a35 35 0 1 0 0 70h781a35 35 0 0 0 0-70zM913.38 526.63L543 198.55a35 35 0 0 0-46.14-0.24l-378.2 328.08a35 35 0 0 0 22.94 61.44h187.71v307.82a35 35 0 0 0 35 35h303.15a35 35 0 0 0 35-35V587.83h187.71a35 35 0 0 0 23.21-61.2z m-245.92-8.8a35 35 0 0 0-35 35v307.82H399.31V552.83a35 35 0 0 0-35-35H235.36l284.2-246.54 278.31 246.54z"></path>
  </svg>`)
}

/**
 * 获取一个叉号SVG图片
 * @param {color} color 叉号图片的颜色
 * @param {number} type 图片款式，支持 1/2
 */
export const getXSVG = function (color = '#eee', type = 1) {
  switch (type) {
    case 1:
      return genSVG(`<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <path fill="${color}" d="M507.168 473.232L716.48 263.936a16 16 0 0 1 22.624 0l11.312 11.312a16 16 0 0 1 0 22.624L541.12 507.168 750.4 716.48a16 16 0 0 1 0 22.624l-11.312 11.312a16 16 0 0 1-22.624 0L507.168 541.12 297.872 750.4a16 16 0 0 1-22.624 0l-11.312-11.312a16 16 0 0 1 0-22.624l209.296-209.312-209.296-209.296a16 16 0 0 1 0-22.624l11.312-11.312a16 16 0 0 1 22.624 0l209.296 209.296z"></path>
      </svg>`)
    case 2:
      return genSVG(`<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <circle cx="512" cy="512" r="462" stroke="${color}" stroke-width="40" fill="transparent"/>
      <path fill="${color}" d="M507.168 473.232L716.48 263.936a16 16 0 0 1 22.624 0l11.312 11.312a16 16 0 0 1 0 22.624L541.12 507.168 750.4 716.48a16 16 0 0 1 0 22.624l-11.312 11.312a16 16 0 0 1-22.624 0L507.168 541.12 297.872 750.4a16 16 0 0 1-22.624 0l-11.312-11.312a16 16 0 0 1 0-22.624l209.296-209.312-209.296-209.296a16 16 0 0 1 0-22.624l11.312-11.312a16 16 0 0 1 22.624 0l209.296 209.296z"></path>
      </svg>`)
  }
}
/**
 * 获取一个info图片
 * @param {color} color 图片icon的颜色
 */
export const getInfoSVG = function (color = '#8a8a8a') {
  return genSVG(`<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100" height="100">
  <path fill="${color}" d="M536 480v192a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16V480a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16z m-32-128h16a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16z m8 448c159.056 0 288-128.944 288-288s-128.944-288-288-288-288 128.944-288 288 128.944 288 288 288z m0 48c-185.568 0-336-150.432-336-336s150.432-336 336-336 336 150.432 336 336-150.432 336-336 336z"></path>
  </svg>`)
}
